/* Sweet on Her · theme.js — shared helpers, cart API, funnel hooks. Load first (defer). */
(() => {
  const SOH = window.SOH = window.SOH || {};
  SOH.routes = Object.assign({ root: '/', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart.js', suggest: '/search/suggest.json' }, window.SOH_ROUTES || {});
  SOH.money = (cents, cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD') =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100);
  SOH.emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  SOH.on = (name, fn) => document.addEventListener(name, fn);
  const json = async (url, body) => {
    const res = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw Object.assign(new Error(data.description || data.message || 'Request failed'), { data, status: res.status });
    return data;
  };
  /* Section Rendering API: pass section ids to re-render (e.g. ['cart-drawer','cart-icon-bubble']) */
  SOH.cart = {
    get: () => json(SOH.routes.cart),
    add: (item, sections = ['cart-drawer', 'cart-icon-bubble']) =>
      json(SOH.routes.cartAdd, { items: [Object.fromEntries(Object.entries({ id: Number(item.id), quantity: item.quantity || 1, selling_plan: item.selling_plan ? Number(item.selling_plan) : undefined, properties: item.properties }).filter(([, v]) => v !== undefined))], sections, sections_url: location.pathname }),
    change: (line, quantity, selling_plan, sections = ['cart-drawer', 'cart-icon-bubble', 'main-cart']) => {
      const body = { line, quantity, sections, sections_url: location.pathname };
      if (selling_plan !== undefined) body.selling_plan = selling_plan === '' ? null : Number(selling_plan);
      return json(SOH.routes.cartChange, body);
    },
    attributes: (attributes) => json(SOH.routes.cartUpdate, { attributes })
  };
  /* Swap rendered sections returned by add/change into the page */
  SOH.renderSections = (sections = {}) => {
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('[data-section-id="' + id + '"]').forEach(el => {
        const src = fresh.querySelector('[data-section-id="' + id + '"]') || fresh.body.firstElementChild;
        if (src) el.innerHTML = src.innerHTML;
      });
    });
  };
  SOH.lockScroll = (on) => document.body.classList.toggle('soh-scroll-lock', on);
  /* focus trap for drawers/modals */
  SOH.trapFocus = (root) => {
    const sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      const f = [...root.querySelectorAll(sel)].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    };
    root.addEventListener('keydown', handler);
    const first = root.querySelector(sel); first && first.focus();
    return () => root.removeEventListener('keydown', handler);
  };

  /* ---------- Funnel hooks ---------- */
  const params = new URLSearchParams(location.search);
  const TRACK = /^(utm_[a-z]+|fbclid|ttclid|gclid)$/;
  try {
    const stored = JSON.parse(sessionStorage.getItem('soh_tracking') || '{}');
    let changed = false;
    params.forEach((v, k) => { if (TRACK.test(k) && stored[k] !== v) { stored[k] = v; changed = true; } });
    if (changed) {
      sessionStorage.setItem('soh_tracking', JSON.stringify(stored));
      SOH.cart.attributes(stored).catch(() => {});
    }
    SOH.tracking = stored;
  } catch (e) { SOH.tracking = {}; }

  SOH.funnel = {
    option: params.get('option'),            /* 1box | 3box | once  → read by <soh-purchase-options> */
    add: params.get('add') === '1',          /* add preselected option + open drawer → read by <soh-add-to-cart> */
    openCart: params.get('open_cart') === '1'
  };
  const code = params.get('discount');
  if (code && !sessionStorage.getItem('soh_discount_applied_' + code)) {
    sessionStorage.setItem('soh_discount_applied_' + code, '1');
    localStorage.setItem('soh_discount', code);
    params.delete('discount');
    const back = location.pathname + (params.toString() ? '?' + params : '') + location.hash;
    location.replace('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back));
  }
  document.documentElement.classList.toggle('soh-growth', document.documentElement.dataset.socialProof === 'growth');
  document.addEventListener('DOMContentLoaded', () => { if (SOH.funnel.openCart) SOH.emit('soh:cart:open'); });
})();
